import React from 'react'
import PropTypes from 'prop-types'
import { toggleHover } from '../../helpers'

class HomeNavButton extends React.Component {
  static propTypes = {
    children: PropTypes.string.isRequired,
    click: PropTypes.func.isRequired,
    active: PropTypes.bool,
  }

  state = {hover: ''}

  render() {
    const { hover } = this.state
    const { children, click, active } = this.props
    return (
      <button
        onClick={() => click(children)}
        className={active ? `active ${hover}` : `${hover}`}
        onTouchStart={e => toggleHover(e, this, click, children)}
        onTouchEnd={e => toggleHover(e, this)}
        onMouseEnter={e => toggleHover(e, this)}
        onMouseLeave={e => toggleHover(e, this)}
      >
        {children}
      </button>
    )
  }
}

export default HomeNavButton



// WEBPACK FOOTER //
// /opt/build/repo/src/components/home-page/HomeNavButton.js